import { connect } from "react-redux";
import PropTypes from "prop-types";
import { ToastContainer } from "react-toastr";
import React, { Component } from "react";

export class NotificationsPopup extends Component {
    constructor (props) {
        super(props);
    }

    componentDidUpdate () {
        const toastrProps = {
            "closeButton": true,
            "extendedTimeOut": 1000,
            "timeOut": 5000,
            "showAnimation": "animated fadeIn",
            "hideAnimation": "animated fadeOut"
        };

        const { operationResult } = this.props;
        if (operationResult !== null) {
            if (operationResult.type) {
                this.container.success(operationResult.message, "", toastrProps);
            }
            else if (operationResult.error)
                this.container.error(operationResult.message, "", toastrProps);
            else {
                this.container.success(operationResult.message, "", toastrProps);
            }
        }
    }

    render () {
        return (
            <ToastContainer
                ref={ref => this.container = ref}
                className="toast-top-right"
            />);
    }
}

NotificationsPopup.propTypes = {
    operationResult: PropTypes.any
};

const mapStateToProps = state =>
    ({
        operationResult: state.operationResult
    });

export default connect(mapStateToProps)(NotificationsPopup);
